import { ShoppingActionTypes } from "./shopping.model";

export const initialState = {
    categories: [],
    products: [],
    productList: [],
    cartProducts: [],
    isLoading: false,
    isCartLoading: false,
    cart: [],
    orders: [],
    orderDetail: {},
    orderGroup: {},
    plans: [],
    paymentConfig: {},
    payoutConfig: {},
    bankAccounts: [],
    shippingFees: [],
    allProducts: [],
    instantVideo: {
        audience: [],
        products: [],
        video: "",
        owner: {},
    },
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ShoppingActionTypes.FETCH_CART_REQUEST:
        case ShoppingActionTypes.FETCH_BANK_ACCOUNT_REQUEST:
        case ShoppingActionTypes.CREATE_BANK_ACCOUNT_REQUEST:
        case ShoppingActionTypes.DELETE_BANK_ACCOUNT_REQUEST:
        case ShoppingActionTypes.UPDATE_BANK_ACCOUNT_REQUEST:
        case ShoppingActionTypes.FETCH_ORDER_ID_REQUEST:
        case ShoppingActionTypes.FETCH_PAYMENT_PAYOUT_REQUEST:
        case ShoppingActionTypes.UPDATE_PRODUCT_STATUS_REQUEST:
        case ShoppingActionTypes.FETCH_PRODUCT_REQUEST:
        case ShoppingActionTypes.FETCH_PAYMENT_CONFIG_REQUEST:
        case ShoppingActionTypes.FETCH_PLANS_REQUEST:
        case ShoppingActionTypes.CREATE_ORDERGROUP_REQUEST:
        case ShoppingActionTypes.FETCH_ORDER_REQUEST:
        case ShoppingActionTypes.UPDATE_ORDER_REQUEST:
        case ShoppingActionTypes.UPDATE_CART_REQUEST:
        case ShoppingActionTypes.CREATE_CART_REQUEST:
        case ShoppingActionTypes.FETCH_PRODUCT_IDS_REQUEST:
        case ShoppingActionTypes.FETCH_CATEGORY_REQUEST:
        case ShoppingActionTypes.FETCH_PRODUCTS_REQUEST:
        case ShoppingActionTypes.CREATE_PRODUCT_REQUEST:
        case ShoppingActionTypes.UPDATE_PRODUCT_REQUEST: {
            return Object.assign({}, state, {
                isLoading: true,
                isCartLoading: true,
            });
        }

        case ShoppingActionTypes.SET_INSTANT_VIDEO: {
            return Object.assign({}, state, {
                isLoading: true,
                instantVideo: action.payload,
            });
        }

        case ShoppingActionTypes.UPDATE_ORDER_SUCCESS: {
            let orders = state.orders.map((x) => {
                if (x._id === action.payload.data._id) {
                    x = { ...x, ...action.payload.data };
                }
                return x;
            });
            return Object.assign({}, state, {
                isLoading: false,
                orders: orders,
            });
        }

        case ShoppingActionTypes.FETCH_PRODUCTS_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                allProducts: action.payload.data,
            });
        }

        case ShoppingActionTypes.FETCH_CATEGORY_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                categories: action.payload.data.data,
            });
        }

        case ShoppingActionTypes.FETCH_PRODUCT_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                productList: action.payload.data,
            });
        }

        case ShoppingActionTypes.SELECT_EXISTING_PRODUCT: {
            return Object.assign({}, state, {
                isLoading: false,
                products: [...state.products, action.payload],
            });
        }

        case ShoppingActionTypes.DELETE_EXISTING_PRODUCT: {
            let updatedProducts = state.products.filter(
                (x, index) => index !== action.payload
            );
            return Object.assign({}, state, {
                isLoading: false,
                products: updatedProducts,
            });
        }

        case ShoppingActionTypes.DELETE_EXISTING_ALL_PRODUCT: {
            return Object.assign({}, state, {
                isLoading: false,
                products: [],
            });
        }

        case ShoppingActionTypes.FETCH_PLANS_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                plans: action.payload.data,
            });
        }

        case ShoppingActionTypes.UPDATE_CART_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
            });
        }

        case ShoppingActionTypes.CREATE_PRODUCT_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                products: [...state.products, action.payload.data],
                productList: [...state.productList, action.payload.data],
            });
        }

        case ShoppingActionTypes.FETCH_CART_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                cart: action.payload.data,
                isCartLoading: false,
            });
        }

        case ShoppingActionTypes.FETCH_PRODUCT_IDS_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                cartProducts: action.payload.data.listProduct,
            });
        }

        case ShoppingActionTypes.UPDATE_PRODUCT_SUCCESS: {
            let new_array = state.products.map((element) =>
                element._id === action.payload.data._id
                    ? action.payload.data
                    : element
            );
            let productList_array = state.productList.map((element) =>
                element._id === action.payload.data._id
                    ? action.payload.data
                    : element
            );
            let cart_array = state.cartProducts.map((element) =>
                element._id === action.payload.data._id
                    ? action.payload.data
                    : element
            );
            return Object.assign({}, state, {
                isLoading: false,
                products: new_array,
                productList: productList_array,
                cartProducts: cart_array,
            });
        }

        case ShoppingActionTypes.UPDATE_PRODUCT_STATUS_SUCCESS: {
            let new_array = state.cartProducts.map((element) =>
                element._id === action.payload.data._id
                    ? action.payload.data
                    : element
            );
            return Object.assign({}, state, {
                isLoading: false,
                cartProducts: new_array,
            });
        }

        case ShoppingActionTypes.CREATE_CART_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
            });
        }

        case ShoppingActionTypes.FETCH_ORDER_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                orders: action.payload.data,
            });
        }

        case ShoppingActionTypes.CREATE_ORDERGROUP_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                orderGroup: action.payload.data,
            });
        }

        case ShoppingActionTypes.FETCH_PAYMENT_CONFIG_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                paymentConfig: action.payload.data,
            });
        }

        case ShoppingActionTypes.FETCH_PAYMENT_PAYOUT_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                payoutConfig: action.payload.data,
            });
        }

        case ShoppingActionTypes.FETCH_ORDER_ID_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                orderDetail: action.payload.data,
            });
        }

        case ShoppingActionTypes.FETCH_BANK_ACCOUNT_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                bankAccounts: action.payload.data,
            });
        }

        case ShoppingActionTypes.CREATE_BANK_ACCOUNT_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                bankAccounts: [...state.bankAccounts, action.payload],
            });
        }

        case ShoppingActionTypes.UPDATE_BANK_ACCOUNT_SUCCESS: {
            const updateAccounts = state.bankAccounts.map((x) => {
                if (x.id === action.payload.id) {
                    x = action.payload;
                }
                return x;
            });
            return Object.assign({}, state, {
                isLoading: false,
                bankAccounts: updateAccounts,
            });
        }

        case ShoppingActionTypes.DELETE_BANK_ACCOUNT_SUCCESS: {
            const deletedAccounts = state.bankAccounts.filter(
                (x) => x.id !== action.payload.id
            );
            return Object.assign({}, state, {
                isLoading: false,
                bankAccounts: deletedAccounts,
            });
        }

        case ShoppingActionTypes.FETCH_REVIEW_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                shippingFees: action.payload.data,
            });
        }

        case ShoppingActionTypes.CREATE_REVIEW_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                shippingFees: [...state.shippingFees, action.payload],
            });
        }

        case ShoppingActionTypes.UPDATE_REVIEW_SUCCESS: {
            const updateAccounts = state.shippingFees.map((x) => {
                if (x.id === action.payload.id) {
                    x = action.payload;
                }
                return x;
            });
            return Object.assign({}, state, {
                isLoading: false,
                shippingFees: updateAccounts,
            });
        }

        case ShoppingActionTypes.DELETE_REVIEW_SUCCESS: {
            const deletedAccounts = state.shippingFees.filter(
                (x) => x.id !== action.payload.id
            );
            return Object.assign({}, state, {
                isLoading: false,
                shippingFees: deletedAccounts,
            });
        }

        case ShoppingActionTypes.FETCH_BANK_ACCOUNT_FAILURE:
        case ShoppingActionTypes.CREATE_BANK_ACCOUNT_FAILURE:
        case ShoppingActionTypes.DELETE_BANK_ACCOUNT_FAILURE:
        case ShoppingActionTypes.UPDATE_BANK_ACCOUNT_FAILURE:
        case ShoppingActionTypes.CREATE_CART_FAILURE:
        case ShoppingActionTypes.FETCH_ORDER_ID_FAILURE:
        case ShoppingActionTypes.FETCH_PAYMENT_PAYOUT_FAILURE:
        case ShoppingActionTypes.FETCH_PRODUCT_FAILURE:
        case ShoppingActionTypes.UPDATE_PRODUCT_STATUS_FAILURE:
        case ShoppingActionTypes.FETCH_PAYMENT_CONFIG_FAILURE:
        case ShoppingActionTypes.FETCH_PLANS_FAILURE:
        case ShoppingActionTypes.CREATE_ORDERGROUP_FAILURE:
        case ShoppingActionTypes.FETCH_ORDER_FAILURE:
        case ShoppingActionTypes.UPDATE_CART_FAILURE:
        case ShoppingActionTypes.FETCH_CART_FAILURE:
        case ShoppingActionTypes.UPDATE_ORDER_FAILURE:
        case ShoppingActionTypes.FETCH_PRODUCT_IDS_FAILURE:
        case ShoppingActionTypes.FETCH_PRODUCTS_FAILURE:
        case ShoppingActionTypes.CREATE_PRODUCT_FAILURE:
        case ShoppingActionTypes.FETCH_CATEGORY_FAILURE:
        case ShoppingActionTypes.UPDATE_PRODUCT_FAILURE: {
            return Object.assign({}, state, {
                isLoading: false,
                isCartLoading: false,
            });
        }

        case ShoppingActionTypes.CLEAR_SHOPPING_REQUEST: {
            return Object.assign({}, state, {
                categories: [],
                products: [],
                productList: [],
                isLoading: false,
            });
        }

        default: {
            return state;
        }
    }
};

export { reducer as ShoppingReducer };
